const domainPattern = /(https?:\/\/)?([^.]*?)\.?([^.]+)\.(net|it)(:\d+)?/;
const parseUrl = (hostname) => {
    const m = hostname.match(domainPattern);
    if (m) {
        return {
            subdomain: m[2],
            domain: `${m[3]}.${m[4]}`,
        };
    }
    return null;
};
export const TOKEN_NAME = "token";
export const getCookieDomain = (hostname) => {
    const m = parseUrl(hostname);
    if (m)
        return `.${m.domain}`;
    return "";
};
